import { ModelSagres } from "@/types/model-sagres";
import { RespostaDetalheSerigy } from "./resposta-detalhe-serigy";
import { EnumTipoAnaliseId } from "./enum-tipo-analise-id";

export class AtributoSerigy extends ModelSagres {
    id: number
    atributoDs: string
    respostas: RespostaDetalheSerigy[]

    // transientes
    temRespostaAuditor: boolean
    pontoGeral: boolean
    cpfAuditor: string | null
    // criterio pai desse atributo
    criterioId: number

    constructor(obj?: any) {
        super()
        if (obj) {
            if (obj.id) this.id = obj.id
            if (obj.atributoDs) this.atributoDs = obj.atributoDs
            if (obj.respostas) this.respostas = obj.respostas.map(r => new RespostaDetalheSerigy(r))

            // transientes
            this.temRespostaAuditor = this.respostas.some((r) =>
                r.tipoAnaliseId === EnumTipoAnaliseId.AUDITOR
            )

            let index = this.respostas.findIndex((r) =>
                r.tipoAnaliseId === (this.temRespostaAuditor
                    ? EnumTipoAnaliseId.AUDITOR
                    : EnumTipoAnaliseId.IA
                )
            )
            if (index == -1 || index === undefined)
                index = this.respostas.findIndex((r) =>
                    r.tipoAnaliseId === EnumTipoAnaliseId.BOT
                )
            this.pontoGeral = this.respostas[index]?.ponto ?? false

            this.cpfAuditor = this.respostas.find((r) => r.cpfAuditor)?.cpfAuditor ?? null
            if (obj.criterioId) this.criterioId = obj.criterioId
        }
    }
}
